
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.02 3c.412 0 .745.333.745.743v2.76a.743.743 0 01-1.488 0v-2.76c0-.41.333-.743.744-.743zm8.026 0c.41 0 .744.333.744.743v2.76a.743.743 0 01-1.488 0v-2.76c0-.41.333-.743.744-.743zM4.85 5.494a.357.357 0 00-.357.357v2.842l15.019.052V5.85a.357.357 0 00-.357-.357h-.14a.743.743 0 110-1.485h.14c1.019 0 1.845.824 1.845 1.842v13.307A1.844 1.844 0 0119.155 21H4.85a1.844 1.844 0 01-1.845-1.842v-9.64a.751.751 0 010-.17V5.85c0-1.018.826-1.842 1.845-1.842h.201a.743.743 0 110 1.485H4.85zm-.357 4.684v8.98c0 .197.16.357.357.357h14.305c.197 0 .357-.16.357-.357V10.23l-15.019-.052zm5.756-5.427c0-.41.333-.742.744-.742h2.068a.743.743 0 110 1.485h-2.068a.743.743 0 01-.744-.743z","fill":"#202D38"}})])
          )
        }
      }
    